import { render, staticRenderFns } from "./CountriesPercentile.vue?vue&type=template&id=c02012d4&"
import script from "./CountriesPercentile.vue?vue&type=script&lang=js&"
export * from "./CountriesPercentile.vue?vue&type=script&lang=js&"
import style0 from "./CountriesPercentile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports